import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextH1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M6 7C6 6.44772 5.55228 6 5 6C4.44772 6 4 6.44772 4 7V22C4 22.5523 4.44772 23 5 23C5.55228 23 6 22.5523 6 22V15.5H17V22C17 22.5523 17.4477 23 18 23C18.5523 23 19 22.5523 19 22V7C19 6.44772 18.5523 6 18 6C17.4477 6 17 6.44772 17 7V13.5H6V7Z" }), /* @__PURE__ */ _jsx("path", { d: "M28.5001 13.5C28.5001 13.1312 28.2971 12.7923 27.972 12.6183C27.6468 12.4443 27.2523 12.4634 26.9454 12.668L23.9454 14.668C23.4859 14.9743 23.3617 15.5952 23.6681 16.0547C23.9744 16.5142 24.5953 16.6384 25.0548 16.3321L26.5001 15.3685V25C26.5001 25.5523 26.9478 26 27.5001 26C28.0524 26 28.5001 25.5523 28.5001 25V13.5Z" })]
});
export default SvgTextH1;
